var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 7.33317H8.66602V3.33317C8.66602 3.15636 8.59578 2.98679 8.47075 2.86177C8.34573 2.73674 8.17616 2.6665 7.99935 2.6665C7.82254 2.6665 7.65297 2.73674 7.52794 2.86177C7.40292 2.98679 7.33268 3.15636 7.33268 3.33317V7.33317H3.33268C3.15587 7.33317 2.9863 7.40341 2.86128 7.52843C2.73625 7.65346 2.66602 7.82303 2.66602 7.99984C2.66602 8.17665 2.73625 8.34622 2.86128 8.47124C2.9863 8.59627 3.15587 8.6665 3.33268 8.6665H7.33268V12.6665C7.33268 12.8433 7.40292 13.0129 7.52794 13.1379C7.65297 13.2629 7.82254 13.3332 7.99935 13.3332C8.17616 13.3332 8.34573 13.2629 8.47075 13.1379C8.59578 13.0129 8.66602 12.8433 8.66602 12.6665V8.6665H12.666C12.8428 8.6665 13.0124 8.59627 13.1374 8.47124C13.2624 8.34622 13.3327 8.17665 13.3327 7.99984C13.3327 7.82303 13.2624 7.65346 13.1374 7.52843C13.0124 7.40341 12.8428 7.33317 12.666 7.33317Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus16);
export default __webpack_public_path__ + "static/media/plus-16.4132fa27c58819c05e018d9744baed7a.svg";
export { ForwardRef as ReactComponent };